import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "../base/button";
import { FullSplitDnsDomain } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";
import { toast } from "react-toastify";

/**
 * The properties for {@link DeleteDomainDialog}
 */
export type DeleteDomainDialogProps = {
    /** The Domain */
    domain: FullSplitDnsDomain;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful deletion */
    onDeletion: () => void;
};

/**
 * A dialog to delete a Domain
 */
export default function DeleteDomainDialog(props: DeleteDomainDialogProps) {
    const [t] = useTranslation("dialog-delete-split-dns");

    /**
     * Delete a Domain
     */
    const deleteDomain = async () => {
        await ApiInternal.dns.deleteDomainSplitDns(props.domain.uuid);
        toast.success(t("toast.successfully-deleted-domain"));
        props.onDeletion();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.delete-domain")}</DialogTitle>
            <DialogDescription>{t("description.delete-domain")}</DialogDescription>
            <DialogActions>
                <Button autoFocus={true} onClick={props.onClose}>
                    {t("button.cancel")}
                </Button>
                <Button color={"red"} onClick={async () => await deleteDomain()}>
                    {t("button.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
